import { Box, Typography, Button } from '@mui/material';
import AppStoreBadges from './AppStoreBadges';

export default function Banner() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        maxHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          minHeight: { xs: '80vh', sm: '90vh', lg: '100vh' },
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: { xs: 'space-between', sm: 'space-around' },
          alignItems: 'center',
          width: '100%',
          maxWidth: {
            xs: 280,
            sm: 400,
            md: 500,
            lg: 900,
          },
        }}
      >
        {/* Logo Row */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="img"
            src="/Logo1.svg"
            alt="logo"
            sx={{
              width: { xs: 60, sm: 76, lg: 96, xl: 110 },
              mr: 2,
            }}
          />
        </Box>
        {/* Main Heading */}
        <Typography
          sx={{
            fontSize: {
              xs: '32px',
              sm: '40px',
              md: '48px',
              lg: '6vw',
              xl: '6vw',
            },
            fontWeight: 800,
            color: '#fff',
            fontFamily: 'Rammetto One',
            lineHeight: 1.1,
            maxWidth: {
              xs: 280,
              sm: 400,
              md: 500,
              lg: 640,
              xl: 700,
            },
          }}
        >
          LEVEL UP YOUR GAMING JOURNEY
        </Typography>
        {/* Paragraph */}
        <Typography
          sx={{
            fontSize: { xs: '12px', sm: '14px', lg: '16px' },
            color: '#ccc',
            letterSpacing: '0.05em',
            fontFamily: 'poppins',
            maxWidth: {
              xs: 280,
              sm: 400,
              md: 500,
              lg: '100%',
            },
          }}
        >
          BINGEPLAY. THE TIKTOK FOR GAMES. TRY EVERY GAME BEFORE YOU INSTALL.
        </Typography>
        {/* CTA row: App Store · Sign Up Now · Google Play  (single flex child to preserve original 5-child spacing) */}
        <AppStoreBadges scale={0.78} sx={{ flexWrap: 'nowrap', gap: { xs: 0.75, sm: 1.25 } }}>
          <Button
            href="https://app.funizzle.com/login"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              minWidth: 0,
              flex: '0 0 auto',
              width: { xs: 110, sm: 125, lg: 140 },
              height: { xs: 48 * 0.78, sm: 54 * 0.78, lg: 60 * 0.78 },
              py: 0,
              borderRadius: '12px',
              fontFamily: 'Poppins',
              fontWeight: 700,
              fontSize: { xs: '0.78rem', sm: '0.875rem', lg: '1rem' },
              backgroundColor: '#ef4444',
              boxShadow: 3,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              lineHeight: 1.1,
              transition: '0.3s',
              '&:hover': {
                backgroundColor: '#dc2626',
                transform: 'scale(1.05)',
              },
            }}
          >
            Sign Up
          </Button>
        </AppStoreBadges>
        {/* Animated GIF */}
        <Box
          sx={{
            width: { xs: 160, sm: 180, lg: 200, xl: 220 },
            mt: '-80px',
            mb: '-80px',
          }}
        >
          <Box
            component="img"
            src="/main.gif"
            alt="main animation"
            sx={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </Box>
    </Box>
  );
}
